import { render, staticRenderFns } from "./person-thumb.vue?vue&type=template&id=79e756a8&scoped=true"
import script from "./person-thumb.vue?vue&type=script&lang=js"
export * from "./person-thumb.vue?vue&type=script&lang=js"
import style0 from "./person-thumb.vue?vue&type=style&index=0&id=79e756a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e756a8",
  null
  
)

export default component.exports